import RadioButtonQuest from "../../../../UI/RadioButtonQuest";
import charterhouseclaims from "../../../../../assets/UFC_DC_RF_V1/img/charterhouseclaims.png";
import { useState } from "react";
import pdf from "../../../../../assets/MOCK_OD/img/pdf-svgrepo-com.svg";


const Question118 = ({ clsName, onSelectAnswer, prevQuestion, btnDisable = false }) => {
  const [dropdown, setDropdown] = useState(false);

  //PDF
  const [loa, setLoa] = useState(false);
  const [chAuth, setChAuth] = useState(false);
  const [chWelcomePcp, setChWelcomePcp] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);

  const optionHandle = (e) => {
    onSelectAnswer(e);
  };

  // const handleBack = () => {
  //   prevQuestion("question118");
  // };

  return (
    <div className={`qswiper-slide slide-up-now ${clsName}`}>
      <h2 className="qs-title  ">
        While reviewing your case, we’ve identified a potential opportunity to pursue further claims for mis-sold car finance.      </h2>
      <p className="fs-16">
        We believe our partner, Charterhouse Claims, is well suited to support you with this claim for <mark class="text-highlight">an opportunity to earn £1,000's* or more per car loan!</mark>. If you would like, we may refer your details to them.      </p>
      <ul className="list-content mt-lg-0 mt-2 mb-0">
        <li>This will not reduce your compensation</li>
        <li>
          You are free to choose a different solicitor, you can make a complaint directly with the lender, or you can refer your claim to the Financial Ombudsman Service (FOS) yourself for free.
        </li>
        <li>
          Charterhouse claim’s ability to act independently will not be compromised
        </li>
        <li>
          We may receive a<span class="fw-semibold">&nbsp;<u>referral-fee</u></span>
        </li>
      </ul>
      {/* <p className="fs-16 fw-bolder">
        Would you like us to refer your case for further review?
      </p> */}
      <div className="btn-option optinal-items two-options py-3 slide-up-now py-3">
        <div className="option_but animation-effct">
          <RadioButtonQuest
            key="q118_1"
            className="radio"
            labelName="Yes, Please Pursue"
            labelClassName="align-items-center endQuest"
            onClick={optionHandle}
            value="326"
            name="question118"
            id="326"
            dataQuestId={118}
            dataAnsId={326}
          />
        </div>
        <div className="option_but">
          <RadioButtonQuest
            key="q118_2"
            className="radio"
            labelName="No, Thank You"
            labelClassName="endQuest"
            onClick={optionHandle}
            value="327"
            name="question118"
            id="327"
            dataQuestId={118}
            dataAnsId={327}
          />
        </div>
      </div>
      {/* <p className="fs-14">
        *Estimated outcomes may vary depending on individual circumstances.
      </p> */}
      {/* <div className="mt-2 mb-4 text-center">
        <div>
          {" "}
          <button
            className={`back-btn mainbckBtn bi bi-chevron-left ${btnDisable ? 'hide' : ''}`}
            type="button"
            onClick={handleBack}
            disabled={btnDisable}
          >
            Back
          </button>{" "}
        </div>
      </div> */}
      <div className="d-flex justify-content-center ch_house_claims">
        <img
          src={charterhouseclaims}
          alt="charterhouseclaims"
        />
      </div>
      <p className="text-center p-14">
        <a
          href=""
          onClick={(e) => {
            e.preventDefault();
            setDropdown((prev) => !prev);
          }}
        >
          View Charterhouse Claims Documents
        </a>
      </p>
      {dropdown && (
        <div className="side-toggle bg-white px-3 py-2 mb-3 rounded-3 shadow-sm">
          <ul className="links ps-0 mt-0 mb-0">
            <li>
              <button
                className="btn btn-link fnt-sml"
                onClick={() => {
                  setLoa((prev) => !prev);
                }}
              >
                <img src={pdf} />
                LETTER OF AUTHORITY
              </button>
            </li>
            <li>
              <button
                className="btn btn-link fnt-sml"
                onClick={() => {
                  setChAuth((prev) => !prev);
                }}
              >
                <img src={pdf} />
                CH CERTIFICATE OF AUTHENTICITY
              </button>
            </li>
            <li>
              <button
                className="btn btn-link fnt-sml"
                onClick={() => {
                  setPrivacyPolicy((prev) => !prev);
                }}
              >
                <img src={pdf} />
                Privacy Policy
              </button>
            </li>
            <li>
              <button
                className="btn btn-link fnt-sml"
                onClick={() => {
                  setChWelcomePcp((prev) => !prev);
                }}
              >
                <img src={pdf} />
                CHC WELCOME LETTER PCP
              </button>
            </li>
            <li>
              <button
                className="btn btn-link fnt-sml"
                onClick={() => {
                  setTermsAndConditions((prev) => !prev);
                }}
              >
                <img src={pdf} />
                Terms and Conditions
              </button>
            </li>
          </ul>
        </div>
      )}
      <p className="fs-14">*An FCA investigation revealed that the average customer on a £10,000 PCP agreement over four years has been overcharged by more than £1,100 (<a href="https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/" target="_blank" rel="noopener noreferrer">https://www.thesun.co.uk/money/30635528/car-finance-misselling-scandal-money-fca/</a>)</p>

    </div>
  );
};

export default Question118;
